$(function() {
    $('.js-toggle-more').on('click', function() {
        $('.js-category-content-more, .js-category-content-results').toggleClass('is-open');
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/checkout/filter-more.js